export default "__VITE_ASSET__3125bcec__"